import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template6';

import { HeaderInformation } from './HeaderInformation';

type THeaderProps = Pick<TRecommendation, 'title' | 'description' | 'header'>;

export const Header = ({ title, description, header }: THeaderProps) => {
  return (
    <header className="vitrine-template6__header">
      <div className="vitrine-template6__header--content">
        <HeaderInformation data={header} />
        <h3
          className="vitrine-template6__header--maintitle"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <span
          className="vitrine-template6__header--maindescription"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    </header>
  );
};
